import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PostCategory, PostItem } from 'src/app/types/post';

interface CardImg {
  url: string;
  alt: string;
  aspectRatio: string;
  width?: number;
  height?: number;
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  currentCategory: PostCategory;
  sameDay: boolean = false;
  startDate: string | number | undefined = undefined;
  endDate: string | number | undefined = undefined;
  updatedAt: string | number;

  @Input() data: PostItem;
  @Input() img: CardImg;
  @Input() showType: boolean;
  @Input() hideCategory: boolean = false;
  @Input() hidePrice: boolean = false;

  constructor(private router: Router, private datePipe: DatePipe) {}

  /**
   * Link to detail page dependant on content type
   */
  linkToDetail(item) {
    let url;
    let blog: boolean = undefined;

    if (item.postType === 'blog') {
      url = `/blog/${item.slug}`;
    } else if (item.postType === 'event') {
      url = `/event/${item.slug}`;
    } else if (item.postType === 'offer') {
      url = `/offers/${item.slug}`;
    } else if (item.postType === 'competition' && item.typeSettings.isBlog) {
      url = `/blog/${item.slug}`;
      blog = true;
    } else if (item.postType === 'competition') {
      url = `/competition/${item.slug}`;
    }

    this.router.navigate([url], {
      queryParams: { blog },
    });
  }

  ngOnInit() {
    if (this.data.category?.child?.title) {
      this.currentCategory = this.data.category.child;
    } else {
      this.currentCategory = this.data.category;
    }

    if (this.data.updatedAt) {
      this.updatedAt = Date.parse(this.data.updatedAt.replace(/ /g, 'T'));
    }

    if (this.data.postType !== 'blog' && this.data.typeSettings?.startDate && this.data.typeSettings?.endDate) {
      this.startDate = Date.parse(
        this.data.typeSettings.startDate.replace(/ /g, 'T')
      );
      this.endDate = Date.parse(
        this.data.typeSettings.endDate.replace(/ /g, 'T')
      );
    }

    if (
      this.startDate &&
      this.endDate &&
      this.datePipe.transform(this.startDate, 'yyyy-MM-dd') ===
        this.datePipe.transform(this.endDate, 'yyyy-MM-dd')
    ) {
      this.sameDay = true;
    }
  }
}
